export const LIST_ERROR_SET = 'LIST_ERROR_SET'
export const LIST_LOADING_SET = 'LIST_LOADING_SET'
export const LIST_SET = 'LIST_SET'